// extracted by mini-css-extract-plugin
export default {"overlayImagesContainer":"kL-z","loadingMedia":"lL-z","reviewsImagesAndVideos":"mL-z","limitHeight":"nL-z"};